import { DeliverablePeriodicity } from "../../types";

export const deliverablePeriodicityMap: {
  [key in DeliverablePeriodicity]: string
} = {
  MONTHLY: "Mensual",
  QUARTERLY: "Trimestral",
  BIANNUAL: "Semestral"
};
